module.exports = __webpack_public_path__ + "img/67.6ce62e2c.png";